var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.1846 13.3648V42.2602C45.1846 46.5326 41.7172 50 37.4448 50H16.8053C12.5329 50 9.06543 46.5326 9.06543 42.2602V13.3648C9.06543 9.09244 12.5329 5.625 16.8053 5.625H17.3212V11.3009C17.3212 13.2823 18.9518 14.9128 20.9332 14.9128H33.3169C35.2983 14.9128 36.9288 13.2823 36.9288 11.3009V5.625H37.4448C41.7172 5.625 45.1846 9.09244 45.1846 13.3648ZM36.9288 31.9404C36.9288 31.0942 36.2271 30.3924 35.3808 30.3924H32.4707L31.2942 25.6866C31.0465 24.6959 30.2003 24.0355 29.189 24.0148C28.1364 23.9735 27.3108 24.634 27.0425 25.6247L24.6689 33.9424L23.575 31.7959C23.121 30.9291 22.2541 30.3924 21.284 30.3924H18.8898C18.0436 30.3924 17.3419 31.0942 17.3419 31.9404C17.3419 32.7866 18.0436 33.4884 18.8898 33.4884H20.9744L22.9558 37.348C23.3273 38.091 24.091 38.5451 24.9166 38.5451H25.1436C26.0518 38.4625 26.7948 37.8227 27.0425 36.9558L29.1271 29.6701L29.6018 31.5276C29.8907 32.6834 30.9227 33.4884 32.0991 33.4884H35.4221C36.2683 33.4884 36.9701 32.7866 36.9701 31.9404H36.9288Z",
    fill: "#2342BF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4172 5.625V11.3009C20.4172 11.5898 20.6443 11.8169 20.9332 11.8169H33.3169C33.6059 11.8169 33.8329 11.5898 33.8329 11.3009V5.625H20.4172Z",
    fill: "#375DFB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMar);
export default __webpack_public_path__ + "static/media/mar.e67ebfd924d6dbd0823ce36ea58d8c0e.svg";
export { ForwardRef as ReactComponent };